import React, { useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { LoadingWrapper } from "components/layout"
import CircularProgress from "@rentspree/component-2023.components.organisms.circular-progress"
import { getErrorUrl } from "utils/error-redirect"
import { parse } from "utils/query-parser"
import isEmpty from "lodash/isEmpty"

export const AuthLoadingPlaceholder = () => (
  <LoadingWrapper noneNavbar background="#FFFFFF">
    <CircularProgress size="medium" color="black" />
  </LoadingWrapper>
)

const Callback = () => {
  const { error, logout } = useAuth0()
  useEffect(
    async () => {
      if (!isEmpty(error)) {
        const query = parse(error?.appState?.queryStrings)
        const { continue: continuePath } = query
        logout({
          logoutParams: {
            returnTo: getErrorUrl({
              error: error?.error_description || error?.message,
              continue: continuePath
            })
          }
        })
      }
    },
    [error]
  )
  return <AuthLoadingPlaceholder />
}

export default Callback
